<template>
  <div>
    <Loader v-if="isTableDataLoading"/>
    <div v-else>
        <Table
          :title="$t('views.directorVms.title')"
          :addLabel="$t('views.directorVms.add')"
          :headers="directorHeaders"
          :rows="directorRows"
          :values="directorVms"
          :addPermission="addPermission"
          currentSortKey="name"
          @add="addPool"
          @more="moreInfo"
          @export="exportVms"
        />
    </div>

    <Modal
      name="seeVm"
      :title="directorSeeVm.name">
      <div class="container">
        <Loader v-if="isDataLoading" />
        <table v-else class="table equal-table">
            <tbody class="tbody">
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.host') }} :</td>
                    <td class="td">{{directorSeeVm.director_host_name}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.name') }} :</td>
                    <td class="td">{{directorSeeVm.name}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.os') }} :</td>
                    <td class="td">{{directorSeeVm.os}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.vcpu') }} :</td>
                    <td class="td">{{directorSeeVm.vcpu}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.vram') }} :</td>
                    <td class="td">{{directorSeeVm.vram}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.storage') }} :</td>
                    <td class="td">{{directorSeeVm.storage}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.classement') }} :</td>
                    <td class="td">
                      <i v-if="directorSeeVm.storage_profile == 'gold'" class="icon icon-star is-epsilon"/>
                      <i v-else-if="directorSeeVm.storage_profile == 'silver'" class="icon icon-star is-beta"/>
                      <i v-else class="icon-star is-gamma"/>
                    </td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.power') }} :</td>
                    <td class="td">{{(directorSeeVm.powerOn=='POWERED_ON') ? $t('views.directorVms.config.started') : $t('views.directorVms.config.stopped')}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.aa') }} :</td>
                    <td class="td">
                      <i v-if="directorSeeVm.option_aa" class="icon icon-valid-round-inverse is-success"/>
                      <i v-else class="icon icon-minus is-gray-300"/>
                    </td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.snapshot') }} :</td>
                    <td class="td">
                      {{directorSeeVm.snapshot_date}}
                      <p v-if="directorSeeVm.snapshot_date">{{directorSeeVm.snapshot_date}}</p>
                      <p v-else><i class="icon icon-minus is-gray-300"/></p>
                    <td/>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.container') }} :</td>
                    <td class="td">{{directorSeeVm.container}}</td>
                </tr>
                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.pool') }} :</td>
                    <td class="td">{{directorSeeVm.pool}}</td>
                </tr>

                <tr class="tr">
                    <td class="td">{{ $t('views.directorVms.config.total_storage_allocated') }} :</td>
                    <td class="td">{{directorSeeVm.total_storage_allocated}}</td>
                </tr>

            </tbody>
        </table>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DIRECTOR from '@/api/director'
import Loader from '@/components/Loader.vue'
import Modal from '@/components/Modal.vue'


import { eventHubMixin } from '@/mixins/event'

export default {
  name: 'directorVms',
  mixins: [eventHubMixin],
  components: {
    Table: () => import('@/components/Table'),
    Loader,
    Modal,
  },
  data() {
    return {
      isDataLoading: true,
      directorSeeVm: {},
      directorHeaders: [
        {
          label: this.$t('views.directorVms.config.name'),
          field: 'name',
          title: this.$t('views.directorVms.config.name_title'),
        },
        {
          label: this.$t('views.directorVms.config.os'),
          field: 'os',
          title: this.$t('views.directorVms.config.os_title'),
        },
        {
          label: this.$t('views.directorVms.config.vcpu'),
          field: 'vcpu',
          title: this.$t('views.directorVms.config.vcpu_title'),
        },
        {
          label: this.$t('views.directorVms.config.vram'),
          field: 'vram',
          title: this.$t('views.directorVms.config.vram_title'),
        },
        {
          label: this.$t('views.directorVms.config.classement'),
          field: 'storage_profile',
          title: this.$t('views.directorVms.config.classement_title'),
        },
        {
          label: this.$t('views.directorVms.config.power'),
          field: 'powerOn',
          title: this.$t('views.directorVms.config.power_title'),
        },
        {
          label: this.$t('views.directorVms.config.aa'),
          field: 'option_aa',
          title: this.$t('views.directorVms.config.aa_title'),
        },
        {
          label: this.$t('views.directorVms.config.snapshot'),
          field: 'snapshot_date',
          title: this.$t('views.directorVms.config.snapshot_title'),
        },
        {
          label: this.$t('views.directorVms.config.container'),
          field: 'container',
          title: this.$t('views.directorVms.config.container_title'),

        },
        {
          label: this.$t('views.directorVms.config.total_storage_allocated'),
          field: 'total_storage_allocated',
        },
      ],
      directorRows: [
        {
          value: row => row.name,
        },
        {
          value: row => row.os,
        },
        {
          value: row => row.vcpu,
        },
        {
          value: row => row.vram,
        },
        {
          icon: () => 'star',
          color: (row) => {
            if (row.storage_profile === 'gold') {
              return 'epsilon'
            } if (row.storage_profile === 'silver') {
              return 'beta'
            }
            return 'gamma'
          },
        },
        {
          value: row => ((row.powerOn === 'POWERED_ON') ? this.$t('views.directorVms.config.started') : this.$t('views.directorVms.config.stopped')),
          classList: 'is-xsmall',
        },
        {
          icon: row => ((row.option_aa) ? 'valid-round-inverse' : 'minus'),
          color: (row) => {
            if (row.option_aa) {
              return 'success'
            }
            return 'gray-300'
          },
        },
        {
          value: row => row.snapshot_date,
          icon: row => ((row.snapshot_date) ? '' : 'minus'),
          color: (row) => {
            if (row.snapshot_date) {
              const match = row.snapshot_date.match(/.+?(?=d)/)[0]
              if (match > 5) {
                return 'danger'
              } if (match > 2) {
                return 'warning'
              }
              return ''
            }
            return 'gray-300'
          },
        },
        {
          value: row => row.container,
        },
        {
          value: row => row.total_storage_allocated,
        },
      ],
      directorVms: [],
      isTableDataLoading: true,
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      hasSignedAdditionalContract: 'auth/hasSignedAdditionalContract'
    }),

    addPermission() {
      if ((this.user.is_admin || this.user.roles_obj.some(role => role.opening_pool_create_ticket)) && this.hasSignedAdditionalContract) {
        return true
      }
      return false
    },
  },

  created() {
    this.listVms()
  },

  methods: {
    listVms() {
      DIRECTOR.vms().then(
        (res) => {
          if (res.data && res.data.length) {
            this.directorVms = res.data
          }
          this.isTableDataLoading = false
        },
      )
    },

    addPool() {
      this.emitOpenModal('add-edit-pool')
    },

    exportVms() {
      DIRECTOR.export()
    },

    moreInfo(data) {
      this.isDataLoading = true
      const params = { vm_url: data.vm_url, vdc_url: data.vdc_url, director_host: data.director_host }
      this.directorSeeVm = {}
      DIRECTOR.vm(params).then(
        (res) => {
          this.directorSeeVm = { ...data, ...res.data }
          this.isDataLoading = false
        },
        this.emitOpenModal('seeVm'),
      )
    },
  },
}
</script>
